export default {
  "content": "<path d=\"M9.125 15.833v-4.958H4.167v-1.75h4.958V4.167h1.75v4.958h4.958v1.75h-4.958v4.958h-1.75z\" fill=\"#414159\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none"
  }
};